// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.day-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}
.day-container p {
  margin: 0 !important;
  font-size: 1rem;
  color: #707070;
}
.day-container .day-name {
  font-weight: 700;
}
.day-container .day-number {
  font-weight: 600;
}
.day-container .selected {
  color: #ed143d;
}

.days-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  max-width: 678px;
  margin: 0 auto;
  padding: 0.5rem 0;
}`, "",{"version":3,"sources":["webpack://./src/app/calendar-view/calendar-days/calendar-days.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;AACF;AACE;EACE,oBAAA;EACA,eAAA;EACA,cAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;AAGE;EACE,gBAAA;AADJ;AAIE;EACE,cAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAHF","sourcesContent":[".day-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n\n  p {\n    margin: 0 !important;\n    font-size: 1rem;\n    color: #707070;\n  }\n\n  .day-name {\n    font-weight: 700;\n  }\n\n  .day-number {\n    font-weight: 600;\n  }\n\n  .selected {\n    color: #ed143d;\n  }\n}\n\n.days-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  max-width: 678px;\n  margin: 0 auto;\n  padding: 0.5rem 0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
